import { SEND_OTP, SEND_OTP_SUCCESS, VERIFY_OTP, VERIFY_OTP_SUCCESS } from "../actionTypes";

export function sendOTP(data,callback) {
  return {
    data,
    type: SEND_OTP,callback
  };
}

export function sendOTPSuccess(data, modalShow) {
  return {
    data,
    modalShow,
    type: SEND_OTP_SUCCESS
  };
}

export function verifyOTP(data,callback) {
  return {
    data,
    type: VERIFY_OTP,callback
  };
}

export function verifyOTPSuccess(data, modalShow) {
  return {
    data,
    modalShow,
    type: VERIFY_OTP_SUCCESS
  };
}